<template>
  <div class="page-bottom">
    <div class="menu-list">
      <div 
        class="item"
        v-for="(menu, idx) in config.Footer" 
        :key="idx"
      >
        <h3><img :src="require(`@/img/footer/2x/${menu.id}.png`)"/></h3>
        <!-- 一栏里有两组带子项的（产品与技术下的「全屋活水」「建筑管路」）横排两栏，
             否则这一列会比其它列长一倍，页脚整体失衡 -->
        <ul :class="{ 'two-col': isTwoCol(menu) }">
          <div 
            v-for="(item, index) in menu.list" 
            :key="index"
          >
          <li><a :href="item.url" class="item-link font">{{ item.title }}</a></li>
          <li 
            class="sub"
            v-for="(sub_item, sub_index) in item.sub_list" 
            :key="sub_index"
          ><a :href="sub_item.url" class="item-link font">{{ sub_item.title }}</a></li>
          </div>
          <!-- <li class="sub"><a href="/product-six-dimensional" class="item-link font">六维全面水管理体系</a></li> -->
        </ul>
      </div>
      <!-- <div class="item">
          <h3>
              <img 
                  src="../../img/footer/2x/1.png"
              />
          </h3>
          <ul>
              <li><a href="/product-solution" class="item-link font">全屋活水解决方案</a></li>
              <li class="sub"><a href="/product-six-dimensional" class="item-link font">六维全面水管理体系</a></li>
              <li class="sub"><a href="/product-supply-system" class="item-link font">给水系统</a></li>
              <li class="sub"><a href="/product-drainage-system" class="item-link font">排水系统</a></li>
          </ul>
      </div>
      <div class="item">
          <h3><img src="../../img/footer/2.png" /></h3>
          <ul>
              <li><a href="/service" class="item-link">班管家365服务</a></li>
              <li><a href="https://oms.idcgroup.com.cn:8082/BGJGZH/index.html" class="item-link">班管家服务平台</a></li>
              <li><a href="/service2" class="item-link">班管家系统配置</a></li>
          </ul>
      </div>
      <div class="item">
          <h3><img src="../../img/footer/3.png" /></h3>
          <ul>
              <li><a href="/life" class="item-link">知水擅水</a></li>
              <li><a href="/appointment" class="item-link">展厅预约</a></li>
          </ul>
      </div>
      <div class="item">
          <h3><img src="../../img/footer/4.png" /></h3>
          <ul>
              <li><a href="/about" class="item-link">关于班尼戈</a></li>
              <li><a href="/explore" class="item-link">百年传承</a></li>
              <li><a href="/news" class="item-link">新闻动态</a></li>
              <li><a href="javascript:;" class="item-link">优秀案例</a></li>
              <li class="sub"><a href="/global-case" class="item-link">全球案例</a></li>
              <li class="sub"><a href="/china-case" class="item-link">中国案例</a></li>
              <li><a href="/contact" class="item-link">联系我们</a></li>
          </ul>
      </div>
      <div class="item">
          <h3><img src="../../img/footer/5.png" /></h3>
          <ul>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%99%AE%E4%B9%90%E4%BB%95%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="item-link">普乐仕系列</a></li>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E8%B4%9D%E7%91%9E%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="item-link">贝瑞斯系列</a></li>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%B3%95%E6%96%AF%E7%89%B9%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="item-link">法斯特系列</a></li>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%A2%B5%E5%B0%94%E8%A5%BF_%E4%BC%8A%E8%80%90%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf" class="item-link">梵尔西/伊耐斯系列</a></li>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E4%BD%8F%E5%AE%85%E7%BB%99%E6%B0%B4%E9%98%80%E9%97%A8%E7%B3%BB%E5%88%97.pdf" class="item-link">住宅给水阀门系列</a></li>
              <li><a href="https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%E5%B7%A5%E7%A8%8B%E7%BB%99%E6%B0%B4%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C.pdf" class="item-link">工程不锈钢系列</a></li>
          </ul>
      </div> -->
      <div class="item">
          <h3><img src="../../img/footer/6.png" /></h3>
          <div 
            class="p" 
            v-for="(item, index) in config.Contact" 
            :key="index"
            v-html="item" 
          >
          </div>
          <!-- <div class="p">
              国内服务/招商电话：4001085686<br/>
              传真：0574-27670680
          </div>
          <div class="p">
              中国总部：<br/>
              浙江省宁波市鄞州区泰康中路558号国贸中心A座39楼
          </div>
          <div class="p">
              物流中心地址：<br/>
              浙江省嘉兴市海盐县经济开发区棕榈路 555 号
          </div>
          <div class="p">
              邮箱：nbibp@ibpchina.com<br/>
              网址：<a href="http://www.conexbanninger.com">http://www.conexbanninger.com</a>
              <br/><a href="http://beian.miit.gov.cn/">沪ICP备16013855号-1</a>
          </div> -->
      </div>
      <div class="item">
          <h3><img src="../../img/footer/7.png" /></h3>
          <div class="qrcode">
              <img src="../../img/footer/wx-qrcode.jpg" />
          </div>
          <h3><img src="../../img/footer/8.png" /></h3>
          <div class="icons">
              <a href="https://weibo.com/u/7825438532" target="_blank"><img src="../../img/footer/icon-1.png" /></a>
              <a href="https://www.xiaohongshu.com/user/profile/5ed45cf500000000010007d3?xhsshare=CopyLink&appuid=5bee41c9a085df0001e2a91b&apptime=1685501043" target="_blank"><img src="../../img/footer/icon-2.png" /></a>
              <!-- <a href="javascript:;" slot="reference"><img src="../../img/footer/icon-3.png" /></a> -->
              <el-popover
                  placement="left-start"
                  title=""
                  width="150"
                  trigger="hover"
              >
              <div class="popover-content">
                  <img src="../../img/footer/wx-video-qrcode.jpg" class="video" />
              </div>
              <a href="javascript:;" slot="reference"><img src="../../img/footer/icon-3.png" /></a>
              </el-popover>
          </div>
      </div>
    </div><!-- menu-list -->
  </div><!-- page-bottom -->
</template>

<script>
// import axios from 'axios'
export default {
  data() {
    return {
      config: []
    }
  },
  mounted() {
    // async someMethod() {
    //   const baseUrl = process.env.BASE_URL;
    //   const data = await this.someHttpClient.get(`${ baseUrl }/Data.json`);
    // }
    // const baseUrl = process.env.BASE_URL;
    // axios.request({
    //   //  url: '/config.json',
    //    url: `${ baseUrl }/config.json`,
    //    method: 'get',
    // }).then(res => {
    //   console.log(res)
    //   this.config = res.data
    // }).catch(err => {
    //   console.log(err)
    //   alert("抱歉，服务出错！")
    // })
    // console.log(this.config)
    this.loadConfig()
  },
  methods: {
    /** 该栏下有两组及以上「带子项」的分组时，改成两栏横排 */
    isTwoCol(menu) {
      const list = (menu && menu.list) || []
      return list.filter(i => i.sub_list && i.sub_list.length).length > 1
    },
    loadConfig() {
      fetch("/config.json")
        // 第一个 then 接受到的是请求头的相关信息
        .then((res) => {
          // console.log(res); //拿到的是一个状态码
          //用json格式读出来，也可以改为text，得到的就是一个text字符串，但是要做一个json解析，所以极少用text格式
          return res.json();
        })
        //第二个.then拿到的是从后端请求回来的真正的数据
        //想要获取响应数据，需在第一个then中将响应数据转为json再返回给第二个then，在第二个then中去获取值
        .then((res) => {
          this.config = res;
          console.log(this.config)
          // console.log(res);
        })
        // 请求错误时执行
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>

<style scoped lang="less">
.detail-popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  min-height: 80px;
  min-width: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(8, 60, 101, 0.3);
  border-radius: 4px 4px 0px 0px 0px 4px 4px;
  transition: all 500ms;
  opacity: 0;
  ::-webkit-scrollbar {
    height: 8px;
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #eaecf1;
    border-radius: 3px;
  }
  &__wrapper {
    &--top {
      height: 100%;
      width: 100%;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: -5px;
        top: 20px;
        width: 0;
        height: 0px;
        border-style: solid;
        border-width: 5px;
        border-color: #fff #fff transparent transparent;
        transform: rotate(-135deg);
        box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
      }
    }
    &--bottom {
      height: 100%;
      width: 100%;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: -5px;
        bottom: 20px;
        width: 0;
        height: 0px;
        border-style: solid;
        border-width: 5px;
        border-color: #fff #fff transparent transparent;
        transform: rotate(-135deg);
        box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
      }
    }
  }
}
</style>